<template>
<div>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <div class="panel-stats">
        <div class="graph-actions">
            <b-button class="graph-action" type="is-info" size="is-small" @click="exportData()">{{ texts.export }}</b-button>
            <b-field class="graph-action">
                <b-select size="is-small" v-model="yearSelected" @input="getStats(yearSelected)">
                    <option
                        v-for="year in yearsAllowed"
                        :value="year"
                        :key="year">
                            {{ year }}
                    </option>
                </b-select>
            </b-field>
        </div>
        <div class="graph" id="stats"></div>
    </div>
    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
    </div>
</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';
import ApexCharts from 'apexcharts'

export default {
    name: 'Stats',
    mixins: [ Utils ],
    data () {
        return {
            config: {},
            texts: {},
            stats: [],
            isLoading: true,
            yearSelected: null,
            yearsAllowed: [],
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (!HealthCareService.isLogged()) this.$router.push('/');
        this.getYears();
    },
    methods: {
        setLoading(isLoading) {
            this.isLoading = isLoading;
        },
        back() {
            this.$router.push('/professional/call');
        },
        getYears() {
            HealthCareService.getYears()
                .then(res => {
                    this.yearsAllowed = res.data;
                    this.yearSelected = this.yearsAllowed[this.yearsAllowed.length - 1];
                    this.getStats(this.yearSelected);
                })
                .catch(error => {
                    this.setLoading(false);
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        getStats(year) {
            HealthCareService.getStats(year)
                .then(res => {
                    this.setLoading(false);
                    this.stats = res.data;
                    this.renderGraph(this.stats.total);
                })
                .catch(error => {
                    this.setLoading(false);
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        renderGraph(total) {
            const emails = new Array(12).fill(0);
            const sms = new Array(12).fill(0);
            const calls = new Array(12).fill(0);
            for (let i in total) {
                const m = total[i].month - 1;
                emails[m] = total[i].emails;
                sms[m] = total[i].sms;
                calls[m] = total[i].calls;
            }
            const options = {
                chart: {
                    height: 350,
                    type: "area",
                    stacked: false,
                    toolbar: { show: false },
                    zoom: { enabled: false },
                },
                dataLabels: { enabled: false },
                colors: ['#66C7F4', '#C5EDAC', '#F08080'],
                series: [
                    { name: "Emails", data: emails },
                    { name: "SMSs", data: sms },
                    { name: "Calls", data: calls },
                ],
                stroke: { curve: 'smooth' },
                plotOptions: { bar: { columnWidth: "20%" } },
                xaxis: { categories: this.texts.when.months },
                tooltip: {
                    x: { show: false }
                },
                legend: {
                    horizontalAlign: "center",
                    offsetX: 40
                },
            };
            document.querySelector('#stats').innerHTML = '';
            const chart = new ApexCharts(document.querySelector('#stats'), options);
            chart.render();
        },
        exportData() {
            const headers = {
                professional: 'Professional',
                year: "Year",
                month: "Month",
                emails: "Emails",
                sms: "SMSs",
                calls: "Calls"
            };
            const file = `stats-${this.yearSelected}`;
            this.exportCSVFile(headers, this.stats.all, file);
        },
    },
}
</script>

<style scoped lang="scss">

.panel-stats {
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    .graph {
        width: auto;
        max-width: 800px;
        margin: 0 auto;
    }
    .graph-actions {
        max-width: 800px;
        margin: 0 auto;
        width: 100%;
        text-align: right;
        .graph-action {
            display: inline-flex;
            margin-left: auto;
        }
    }
}

.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/Stats.vue